import { UI_MESSAGES_SET_SHOW_TRANSLATED } from 'actions/types';

/**
 * Updates state.ui.messages.showTranslated.
 * @param {bool} payload
 */
export const setShowTranslated = (show) => ({
  type: UI_MESSAGES_SET_SHOW_TRANSLATED,
  show,
});
